import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/default.vue").then(m => m.default || m)),
  private: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/private.vue").then(m => m.default || m))
}